<template>
  <div class="p-4 md:p-6 flex-1 overflow-y-auto font-sans">

    <!-- ── Section Header ── -->
    <div class="flex items-center justify-between mb-6 pb-5
                border-b border-primary-100 dark:border-dark-600">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-primary-50 dark:bg-primary-400/15
                    flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
        </div>
        <div>
          <h1 class="font-display text-xl md:text-2xl font-extrabold tracking-tight
                     text-dark-700 dark:text-white">
            User Management
          </h1>
          <p class="text-[13px] text-muted dark:text-muted-light mt-0.5">
            Manage accounts and permissions
          </p>
        </div>
      </div>
    </div>

    <Breadcrumbs />

    <!-- ── Content ── -->
    <div class="bg-surface dark:bg-dark-700 rounded-card shadow-card
                border border-primary-100 dark:border-dark-600 p-6
                transition-colors duration-300">
      <UsersList :users="users" />
    </div>

  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import UsersList from "@/components/UsersList.vue";
import { apiDataService } from "@/services/apiDataService";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
  name: "UserList",
  components: { UsersList, Breadcrumbs },

  setup() {
    const users = ref([]);

    const getUsers = async () => {
      try {
        const response = await apiDataService.getUsers();
        users.value = response.data;
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    onMounted(() => { getUsers(); });

    return { users };
  },
};
</script>